import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryIndividualRosterEntryData from './GetOrgUnitAthleteEntryIndividualRosterEntryData';
import getOrgUnitAthleteEntryBonusIndividualRosterEntryData from './GetOrgUnitAthleteEntryBonusIndividualRosterEntryData';
import putOrgUnitAthleteEntryIndividualRosterEntryData from './PutOrgUnitAthleteEntryIndividualRosterEntryData';
import putOrgUnitAthleteEntryAthleteEntryIndividualRosterEntryData from './PutOrgUnitAthleteEntryAthleteEntryIndividualRosterEntryData';
import putOrgUnitAthleteEntryApproveIndividualEventsData from './PutOrgUnitAthleteEntryApproveIndividualEventsData';

import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  orgUnitAthleteEntryId: Constants.DEFAULT_ID
};

const OrgUnitAthleteEntryIndividualRosterEntryData = {
  INITIAL_STATE,
  getOrgUnitAthleteEntryIndividualRosterEntryData,
  getOrgUnitAthleteEntryBonusIndividualRosterEntryData,
  putOrgUnitAthleteEntryIndividualRosterEntryData,
  putOrgUnitAthleteEntryAthleteEntryIndividualRosterEntryData,
  putOrgUnitAthleteEntryApproveIndividualEventsData
}

export default OrgUnitAthleteEntryIndividualRosterEntryData;